import React from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import styles from './Arrows.module.scss';
const Arrows = ({
  datePickerIsInCurrentMonth,
  isLastMonth,
  onNextPrevMonthClick,
  months,
  dateType,
  monthNameConvertor
}) => {
  return <Box className={styles['arrow']} data-sentry-element="Box" data-sentry-component="Arrows" data-sentry-source-file="Arrows.tsx">
      <Box className={`${styles['calendar-arrow-right']} ${datePickerIsInCurrentMonth ? styles['calendar-arrow-right-disabled'] : ''}`} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
        <Box component="button" onClick={() => onNextPrevMonthClick(0)} className={styles['arrow-buttons']} style={{
        opacity: datePickerIsInCurrentMonth ? 0.2 : 1,
        pointerEvents: datePickerIsInCurrentMonth ? 'none' : 'unset'
      }} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
          <Icon type={datePickerIsInCurrentMonth ? 'lowEmphasis' : 'inherit'} name="arrow-right-1" data-sentry-element="Icon" data-sentry-source-file="Arrows.tsx" />
        </Box>
      </Box>

      <Box className={styles['date-months-names']} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
        {monthNameConvertor(months[0], dateType)} {months[0]?.year}
      </Box>

      <Box className={`${styles['calendar-arrow-left']} ${isLastMonth() ? styles['calendar-arrow-left-disabled'] : ''}`} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
        <Box component="button" onClick={() => onNextPrevMonthClick(1)} className={styles['arrow-buttons']} style={{
        opacity: isLastMonth() ? 0.2 : 1,
        pointerEvents: isLastMonth() ? 'none' : 'unset'
      }} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
          <Icon type={isLastMonth() ? 'lowEmphasis' : 'inherit'} name="arrow-left" data-sentry-element="Icon" data-sentry-source-file="Arrows.tsx" />
        </Box>
      </Box>
    </Box>;
};
export default Arrows;